// Function to create the FontAwesome icon as a string
export const createFontAwesomeIcon = (iconString: string, color = '#000000', size = 15) => {
  let iconWithColor = iconString;
  if (iconString.includes('<svg')) {
    // Remove any existing fill attributes
    iconWithColor = iconWithColor.replace(/fill=['\"](.*?)['\"]/g, '');
    // Add the desired fill attribute
    iconWithColor = iconWithColor.replace('<svg', `<svg fill='${color}'`);
  }
  // If not SVG, do not add any style or span
  return `
    <svg width="${size}" height="${size + 1}" xmlns="http://www.w3.org/2000/svg">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml">
          ${iconWithColor}
        </div>
      </foreignObject>
    </svg>
  `;
};